<template>
  <div>
    <v-autocomplete
      :value="consignor"
      :items="filterConsignors"
      :label="$i18n.t(label)"
      @change="changedTo"
      @click:clear="clear"
      :loading="c_loading"
      :clearable="clearable"
      :rules="rules"
      :search-input.sync="filter"
      ref="select"
      autocomplete="nope"
      :no-filter="true"
      v-if="hide === false"
    >
      <template v-slot:selection="data">
        <div ripple dense class="height32">
          <h5 class="text-title">{{ data.item.name }}</h5>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.name }}
              <v-icon small v-if="selected(data.item)" style="float: right"
                >mdi-check</v-icon
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
      <template v-slot:append-item>
        <div class="actionBox">
          <v-btn small text color="info" @click="consignorCreateDialog = true">
            <v-icon>mdi-plus</v-icon>
            {{ $i18n.t("Add New") }}
          </v-btn>
        </div>
      </template>
    </v-autocomplete>
    <z-consignor-create
      @select="selectConsignor"
      :showDialog="consignorCreateDialog"
      :type="type"
      :addNewLabel="addNewLabel"
    ></z-consignor-create>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import corpService from "@/store/common/module/CorpService";

import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "ConsignorSelect",
  props: {
    value: {
      default: false,
    },
    label: {
      default: "Consignor",
    },
    addNewLabel: {
      default: "Consignor",
    },
    clearable: {
      default: false,
    },
    type: {
      default: null,
    },
    isName: {
      default: null,
    },
    rules: {
      default: () => [],
    },
    item: {
      default: null,
    },
  },
})
export default class ConsignorSelect extends (Vue, Themeable) {
  consignor = null;
  consignors = [];
  c_loading = true;
  filter = "";
  hide = false;
  consignorCreateDialog = false;
  selectedValue = null;

  async selectConsignor(newConsignor) {
    this.consignorCreateDialog = false;
    if (newConsignor) {
      corpService.clearConsignors();
      this.selectedValue = newConsignor;
      await this.init(this.type);
    }
  }

  clear() {
    this.filter = "";
    this.consignor = null;
    this.$emit("input", null);
  }

  get filterConsignors() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    if (filterby == "") return this.consignors;
    const fs = this.consignors.filter(function (s) {
      return s.name && s.name.toLowerCase().indexOf(filterby) >= 0;
    });
    return fs;
  }

  changedTo(newVal) {
    this.filter = "";
    if (newVal) {
      this.consignor = newVal;
    }
    if (newVal && newVal.name) {
      if (this.isName) {
        this.$emit("input", newVal.name);
      } else {
        this.$emit("input", newVal);
      }
    }
    if (!newVal) {
      this.$emit("input", null);
    }
  }

  selectValue() {
    if (this.selectedValue) {
      for (let i = 0; i < this.consignors.length; i++) {
        if (this.consignors[i].name === this.selectedValue.name) {
          this.consignor = this.consignors[i];
          if (this.isName) {
            this.$emit("input", this.consignor.name);
          } else {
            this.$emit("input", this.consignor);
          }
          return;
        }
      }
    }
  }

  async init(type) {
    if (type) {
      this.filter = "";
      this.c_loading = true;
      await corpService.populateConsignors(type);
      this.consignors = corpService.consignors[type];
      this.c_loading = false;
      this.selectValue();
    } else {
      this.consignors = [];
      this.c_loading = false;
      this.selectValue();
    }
  }

  async mounted() {
    await this.init(this.type);
    this.c_loading = false;
  }

  selected(val) {
    if (
      val != null &&
      val.name != null &&
      this.consignor != null &&
      this.consignor.name != undefined
    ) {
      if (val.name === this.consignor.name) {
        return true;
      }
    }
    return false;
  }

  @Watch("type", { immediate: true })
  async onTypeChange(val) {
    await this.init(val);
  }

  @Watch("value", { immediate: true })
  onValueChange(newVal) {
    this.selectedValue = newVal;
    this.selectValue();
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.actionBox {
  position: sticky;
  background: white;
  bottom: 0px;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-top: 1px solid #dfdfdf;
  padding: 10px;
}
</style>
